import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuperadminService } from '../../../services/superadmin.service';

@Component({
  selector: 'app-create-organization-dialog',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './create-organization-dialog.component.html',
  styleUrl: './create-organization-dialog.component.scss',
})
export class CreateOrganizationDialogComponent {
  orgName = '';
  saving = false;
  error = '';

  constructor(
    private superadminService: SuperadminService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<CreateOrganizationDialogComponent>,
  ) {}

  onConfirm(): void {
    const name = this.orgName.trim();
    if (!name) return;
    this.saving = true;
    this.error = '';

    this.superadminService.createOrganization(name).subscribe({
      next: () => {
        this.snackBar.open(`Organization "${name}" created.`, 'Close', { duration: 3000 });
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.saving = false;
        this.error = err?.error?.message ?? 'Failed to create organization.';
      },
    });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}